// ABOUTME: Root route defining the router context shape (auth state).
// ABOUTME: Renders a bare <Outlet /> — all layout lives in child routes.

import type { User } from "@supabase/supabase-js";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

interface RouterContext {
  auth: { user: User | null; loading: boolean };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
